import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic-audit-reports',
  templateUrl: './academic-audit-reports.component.html',
  styleUrls: ['./academic-audit-reports.component.scss']
})
export class AcademicAuditReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
